import { useState } from "react";
import { Box, Paper } from "@material-ui/core";
import {
  GetSchoolDocument,
  useClearFailedBasSyncMutation,
} from "../../generated/graphql";
import { ButtonCustom } from "../shared/Style/Style";
import { ErrorMessageSnackbar } from "../shared/ErrorMessageSnackbar";

interface BASSyncTabProps {
  schoolId: string;
  failedBASSync: string;
}

export const BASSyncTab = ({ schoolId, failedBASSync }: BASSyncTabProps) => {
  const [clearFailedBASSync, { loading }] = useClearFailedBasSyncMutation({
    refetchQueries: [{ query: GetSchoolDocument, variables: { id: schoolId } }],
  });

  const [errorOpen, setErrorOpen] = useState(false);

  const handleClear = async () => {
    try {
      await clearFailedBASSync({ variables: { schoolId }, onError: () => {
        setErrorOpen(true);
      }});
    } catch (e) {
      console.error(e);
      setErrorOpen(true);
    }
  };

  return (
    <>
      <Paper elevation={3}>
        <Box p="20px 30px">
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            {failedBASSync?.split(";").map((error) => (
              <li key={error}>{error.trim()}</li>
            ))}
          </ul>
          <Box display="flex" justifyContent="center" mt="20px">
            <ButtonCustom onClick={handleClear} disabled={loading}>
              Очистити
            </ButtonCustom>
          </Box>
        </Box>
      </Paper>

      <ErrorMessageSnackbar
        open={errorOpen}
        closeHandler={() => setErrorOpen(false)}
        message="Не вдалося очистити помилки синхронізації BAS"
      />
    </>
  );
};
